import {config} from '../config';

export default {
    getIsHAVMandatory: () => config.data.hav.isHAVMandatory,
    getIsMarketHAVAvailable: () => config.data.hav.isMarketHAVAvailable,
};
